<template>
    <div class="card mb-3">
        <div class="row no-gutters" v-if="object_packets">
            <div class="col-md-4">
                <div class="p-2">
                    <a :href="object.url" target="_blank">
                        <img :src="object.pic" class="card-img" alt="">
                    </a>
                </div>
            </div>
            <div class="col-md-8">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 col-md-7 p-0 text-center text-md-left">
                            <h5 class="card-title mb-0">
                              <a :href="object.url" target="_blank" style="color: #000000; text-decoration: none;">
                                <span v-b-tooltip.hover.topright :title="object.name">{{title}}</span>
                              </a>
                            </h5>
                            <div class="inserat-id text-muted">Inserats-Nummer: {{object.id}}</div>
                            <div class="unlocked" v-if="object.status == 'ok'">Freigeschaltet</div>
                            <div class="paused" v-if="object.status != 'ok'">Pausiert</div>
                            <!-- Zusatzoptionen -->
                            <template v-if="own_zo && own_zo.length > 0">
                                <div class="zusatz_option" v-for="zo in own_zo" :key="zo.id">{{$t('intern_objekte_list.mit_' + zo.packet_key)}}</div>
                            </template>
                        </div>
                        <div class="col-12 col-md-5 text-center text-md-right">
                            <div class="price" v-if="object.price_info != 'col'">{{object.price_amount | currency}}</div>
                            <div class="font-12" v-if="object.price_info && object.price_amount != '0.00'">pro {{object.price_base}} / {{$t('intern_price.' + object.price_info)}} </div>
                            <div class="font-12" v-else-if="object.price_info && object.price_amount == '0.00'">{{$t('intern_price.' + object.price_info)}} </div>
                            <div class="font-10 text-muted">Eingestellt: {{object.create_date}}</div>
                            <div class="font-10 text-muted" v-if="object.create_date != object.change_date">Aktualisiert: {{object.change_date}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <ul class="control-list pl-2 pb-1">
                    <li
                        @click="pauseObject"
                        v-if="object.status == 'ok'"
                        class="mm-color mr-3"
                    >
                        <font-awesome-icon icon="pause" style="font-sze: 16px;"/>
                        Pausieren
                    </li>
                    <li
                        @click="unlockObject"
                        v-else-if="object.status != 'ok' && (!sepaInfoMissing || user.payment_method == 'ueberweisung')"
                        class="mm-color mr-3"
                        style="color: #f79700;"
                    >
                        <font-awesome-icon icon="play" style="font-sze: 16px;"/>
                        Freischalten
                    </li>
                    <li
                        @click="unlockObject"
                        v-else-if="object.status != 'ok' && sepaInfoMissing"
                        class="mm-color mr-3"
                        style="color: #c0bebd;"
                    >
                        <font-awesome-icon icon="play" style="font-sze: 16px;"/>
                        Freischalten
                    </li>
                    <router-link
                        tag="li"
                        :to="{name: 'inserat-edit', params: {id: object.id}}"
                        class="mm-color mr-3"
                    >
                        <font-awesome-icon icon="edit" style="font-sze: 16px;"/>
                        Bearbeiten
                    </router-link>
                    <li class="mm-color mr-3" @click="highlightObject">
                        <font-awesome-icon icon="highlighter" style="font-sze: 16px;"/>
                        Hervorheben
                    </li>
                    <li class="mm-color mr-3">
                        <a :href="object.url" target="_blank" style="color: #5FA963; text-decoration: none;">
                            <font-awesome-icon icon="eye" style="font-sze: 16px;"/>
                            Vorschau
                        </a>
                    </li>
                    <li class="mm-color mr-3" @click="$emit('openModal', object.id)">
                        <font-awesome-icon icon="copy" style="font-sze: 16px;"/>
                        Daten übernehmen
                    </li>
                    <li class="mm-color mr-3" @click="modal = 'delete'">
                        <font-awesome-icon icon="trash-alt" style="font-sze: 16px;"/>
                        Löschen
                    </li>
                </ul>
            </div>
        </div>
        <!-- MODAL -->
        <b-modal ref="modal" :title="modalTitle" >
            <div class="d-block" v-if="modal == 'delete'">
                <div v-if="own_zo && own_zo.length > 0 " class="alert alert-warning">{{$t('intern_objekte_list.delete_objectpackets')}}</div>
                <div v-else class="alert alert-warning">{{$t('intern_objekte_list.delete_object')}}</div>
            </div>
            <div class="d-block" v-else-if="modal == 'statistik'">
                <table v-if="object['statistik'].length != 0" class="table">
                    <thead>
                        <tr>
                            <th>Jahr - Monat</th>
                            <th>Aufrufe</th>
                            <th>Anfragen</th>
                            <th>Telefon</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(stat, key, index) in object['statistik']" :key="key">
                            <td>{{key}}</td>
                            <td>{{stat.requests ? stat.requests : '0'}}</td>
                            <td>{{stat.queries  ? stat.queries : '0'}}</td>
                            <td>{{stat.calls    ? stat.calls : '0'}}</td>
                        </tr>
                    </tbody>
                </table>
                <div v-else>
                    Keine Statistik ist vorhanden
                </div>
            </div>
            <template slot="modal-footer">
                <b-button variant="secondary"                        @click="clearModal">Schließen</b-button>
                <b-button variant="danger"  v-if="modal == 'delete'" @click="deleteObject">Löschen</b-button>
                <!-- <b-button variant="danger"  v-if="modal == 'pause'"  @click="pauseObject">pausieren</b-button> -->
            </template>
        </b-modal>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                user: null,
                packet: null,
                object_packets: null,
                own_zo: null,
                modal: '',
                modalTitle: '',
                statistikTitle: 'Statistik',
                deleteTitle: 'Möchten Sie das Inserat wirklich löschen?',
                windowWidth: window.innerWidth
            }
        },
        computed: {
            title() {
                if(this.object.name.length > 25 && !this.isMobile){
                    return this.object.name.substring(0, 25) + '...';
                }else{
                    return this.object.name;
                }
            },
            hasPacket() {
                return this.packet && Object.keys(this.packet).length > 0;
            },
            hasObjectPackets() {
                return this.object_packets.some((packet) => packet.gift != 5 && packet.object_id == this.object.id);
            },
            isMobile() {
                return this.windowWidth <= 768
            }
        },
        watch: {
            object_packets: function(val) {
                this.own_zo = val.filter(el => el.object_id == this.object.id);
            },
            modal: function(val) {
                if(val == ''){
                    this.$refs['modal'].hide();
                    this.modalTitle = '';
                }else {
                    this.$refs['modal'].show();

                    if(val == 'delete'){
                        this.modalTitle = this.deleteTitle;
                    }else if(val == 'statistik'){
                        this.modalTitle = this.statistikTitle;
                    }
                }
            },
        },
        props: ['object', 'sepaInfoMissing'],
        methods: {
            clearModal() {
                this.modal = '';
            },
            deleteObject() {
                this.$http.delete('/objectApi/deleteObject', {
                    params: {id: this.object.id}
                    }).then(response => {
                    this.clearModal();
                    this.$emit('success', response.data);
                }).catch(err => {
                    this.clearModal();
                    this.$emit('error', err.response.data.data);
                });
            },
            unlockObject() {
                this.$store.state.loading = true;
                if(this.sepaInfoMissing && this.user && this.user.packet && this.user.packet.type == 'custom' && this.user.payment_method != 'ueberweisung') {
                    console.log('Object');
                    this.$http.get('invoiceApi/getOpenedInvoice').then( response => {
                      this.opened_invoices = JSON.parse(response.data);
                      if(this.opened_invoices.length > 0) {
                        this.sepaInfoMissingAlert(this.opened_invoices[0].id);
                        this.$store.state.loading = false;
                        return;
                      }
                      else{
                        this.$http.put('/objectApi/unlockObject?id='+this.object.id).then(response => {
                            let data = JSON.parse(response.data);

                            if(data.no_packet && this.user.user_type != 'gewerblich'){
                              this.$emit('warning', data.no_packet);

                              //redirect
                              this.$router.push({ name: 'packet-upgrade'});
                            }else if(data.no_packet && this.user.user_type == 'gewerblich') {
                              this.noPacketAlert();
                            } else{
                              this.$emit('success', data.success, false);
                              this.object.status = 'ok';
                              this.$store.dispatch('OVERVIEW');
                            }
                            this.clearModal();
                            this.$store.state.loading = false;
                        }).catch(error => {
                              this.clearModal();
                              this.$emit('error', error.response.data.data);
                              this.$store.state.loading = false;
                            });
                      }
                    });
                }
                else {
                   if(this.user.user_type == 'gewerblich' && !this.packet){
                        this.$store.state.loading = false;
                        this.noPacketAlert();
                   }else if(this.user.user_type != 'gewerblich' && !this.packet){
                        this.$store.state.loading = false;
                        this.$router.push({name: 'inserat-booking', params: {object_id: this.object.id}});
                   }else{
                        this.$http.put('/objectApi/unlockObject?id='+this.object.id).then(response => {
                            let data = JSON.parse(response.data);

                            if(data.no_packet && this.user.user_type != 'gewerblich'){
                                this.$emit('warning', data.no_packet);

                                //redirect
                                this.$router.push({ name: 'packet-upgrade'});
                            }else if(data.no_packet && this.user.user_type == 'gewerblich') {
                                this.noPacketAlert();
                            } else{
                                this.$emit('success', data.success, false);
                                this.object.status = 'ok';
                                this.$store.dispatch('OVERVIEW');
                            }
                            this.clearModal();
                            this.$store.state.loading = false;
                        }).catch(error => {
                            this.clearModal();
                            this.$emit('error', error.response.data.data);
                            this.$store.state.loading = false;
                        });
                   }
                }
            },
            pauseObject() {
                this.$bvModal.msgBoxConfirm('Möchten Sie das Inserat wirklich pausieren?', {
                    okVariant: 'danger',
                    cancelVariant: 'secondary',
                    okTitle: 'Pausieren',
                    cancelTitle: 'Abbrechen'
                }).then(val => {
                    if(val){
                        this.$store.state.loading = true;
                        this.$http.put('/objectApi/pauseObject?id='+this.object.id).then(response => {
                            this.clearModal();
                            this.object.status = 'locked';
                            this.$emit('success', response.data, false);
                            this.$store.state.loading = false;
                            this.$store.dispatch('OVERVIEW');
                        }).catch(error => {
                            this.clearModal();
                            this.$emit('error', error.response.data.data);
                            this.$store.state.loading = false;
                        });
                    }
                });

            },
            highlightObject() {
                if(this.user.user_type == 'gewerblich' && !this.packet){
                    this.$store.state.loading = false;
                    this.noPacketAlert();
                }else if(this.user.user_type == 'gewerblich'){
                    this.$emit('hervorheben', this.object);
                }/*else if(this.user.user_type != 'gewerblich' && this.packet){
                    this.$emit('hervorheben', this.object);
                }*/else {
                    this.$router.push({ name: 'inserat-booking', params: { object_id: this.object.id} });
                }
            },
            sepaInfoMissingAlert(invoiceID){
                let h = this.$createElement;
                let msgNode = h('div', { domProps: {innerHTML: this.$t('intern_paymentdata.nosepa_info_dialog_text')}});

                this.$bvModal.msgBoxConfirm([msgNode], {
                        okVariant: 'success',
                        cancelVariant: 'secondary',
                        okTitle: 'Zur Eingabe der Bankdaten',
                        cancelTitle: 'Schließen'
                }).then(val => {
                      if (val) {
                          location.href  = '/intern/rechnung/bezahlen/' + invoiceID;
                      }
                });
            },
            noPacketAlert() {
                let h = this.$createElement;
                let msgNode = h('div', { domProps: {innerHTML: this.$t('intern_objekte_list.nopacket_gewerblich_dialog_text')}});

                this.$bvModal.msgBoxOk([msgNode], {
                    title: 'Benachrichtigung',
                    okVariant: 'success',
                    okTitle: 'ok',
                });
            },
            showObjectPackets() {
                if(this.hasObjectPackets){
                    this.$http.get('/objectPacketApi/getAllObjectPackets?object_id=' + this.object.id).then(response => {
                        let packets = JSON.parse(response.data);
                        let h       = this.$createElement;
                        let html    = '<ul class="list-group">';
                        packets     = packets.sort( (item1, item2) => {
                            if(item1.id > item2.id){
                                return 1;
                            }
                            if(item1.id < item2.id){
                                return -1;
                            }
                            return 0;
                        });

                        for (const packet of packets) {
                            html += `<li class="list-group-item">${this.packetName(packet.packet_key)}</li>`;
                        }

                        html += '</ul>';

                        let msgNode = h('div', { domProps: {innerHTML: html}});
                        this.$bvModal.msgBoxOk([msgNode], {
                            title: 'Zusatzoptionen',
                            okVariant: 'success',
                            okTitle: 'ok',
                        });
                    }).catch( error => {console.log(error);});
                }
            },
            packetName(name) {
                switch(name){
                    case 'fotolink':
                        return 'Startseiten Fotolink';
                        break;
                    case 'fotokategorie':
                        return 'Kategorie Fotolink';
                        break;
                    case 'weeklypushup':
                        return 'Weekly Pushup';
                        break;
                    case 'dailypushup':
                        return 'Daily Pushup';
                        break;
                    case 'topinserat':
                        return 'Top Inserat';
                        break;
                }
            }
        },
        created() {
            this.user            = this.$store.getters.user;
            this.packet          = this.user.packet;
            this.object_packets  = this.$store.getters.object_packets;

            this.$store.watch(() => {
                return this.$store.getters.user;
            }, user => {
                this.user   = user;
                this.packet = user.packet;
            });

            this.$store.watch(() => {
                return this.$store.getters.object_packets;
            }, object_packets => {
                this.object_packets   = object_packets;
            });

            if(this.$route.name != 'inserat-uebersicht' && !this.$store.state.object_packets){
                this.$store.dispatch('OBJECT_PACKETS');
            }
        },
        mounted() {
            //check window size
            window.addEventListener('resize', () => {
                this.windowWidth = window.innerWidth;
            });
        }
    }
</script>

<style scoped>
.card-body{
    padding: 0.5em 1.25em;
}
.price{
    font-size: 20px;
    font-weight: 800;
}
.unlocked{
    border-radius: 20px;
    padding: 2px 20px;
    border: 1px solid #5FA963;
    color:#5FA963;
    background-color: rgba(95, 169, 99, 0.15);
    display: inline-block;
    font-size: 12px;
    margin: 3px 0;
    margin-right: 5px;
    font-weight: 600;
}
.paused{
    border-radius: 20px;
    padding: 2px 20px;
    border: 1px solid #dc3545;
    color:#dc3545;
    background-color: #dc354610;
    display: inline-block;
    font-size: 12px;
    margin: 3px 0;
    margin-right: 5px;
    font-weight: 600;
}
.zusatz_option{
    border-radius: 20px;
    padding: 2px 20px;
    border: 1px solid rgb(255, 102, 0);
    background-color:#ffcba1d3;
    color: rgb(255, 102, 0);
    display: inline-block;
    font-size: 12px;
    margin: 3px 0;
    margin-right: 5px;
    font-weight: 600;
}
.card, .card-img{
    border-radius: 7px;
}
.card-img{
    height: 150px;
    cursor: pointer;
    border: 1px solid #eeeeee;
}
.inserat-id{
    font-size: 15px;
    vertical-align: middle;
}
.bg-secondary, .bg-success{
    color: white;
}
.actions{
    list-style: none;
    margin: 5px 0 0 0;
    padding: 0;
}
.actions li{
    float: left;
    margin-right: 5px;
}
.cursor {
    cursor: pointer;
}
.control-list{
    display: block;
    padding: 0;
    margin: 0;
}
.control-list li{
    list-style: none;
    display: inline-block;
    font-size: 15px;
    font-weight: 400;
    cursor: pointer;
}

@media (max-width: 767px) {
    .card-img{
        height: auto;
    }
}
</style>
